module.exports = __webpack_public_path__ + "static/img/2.5625b36.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/poster/2.png
// module id = k2hB
// module chunks = 1